import React from 'react';
import {
  chipStyle,
  chipWrapStyle,
  panelSubStyle,
  panelTitleStyle,
  rowMetaStyle,
  rowTitleStyle,
  summaryCardStyle,
} from './dashboardStyles';

function badgeStyle(color) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 6,
    border: `1px solid ${color}`,
    color,
    background: 'var(--bg-card)',
    padding: '2px 6px',
    fontSize: 11,
    fontWeight: 900,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  };
}

export default function SaasReviewDecisionPanel({ items }) {
  if (!items?.length) return null;

  return (
    <div style={{ ...summaryCardStyle, padding: 12, marginTop: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
        <div>
          <h3 style={panelTitleStyle}>검토 필요 의사결정표</h3>
          <div style={{ ...panelSubStyle, whiteSpace: 'normal' }}>
            아직 자동 연결하지 않고, 포함/분리/제외 판단이 필요한 권한만 따로 모았습니다.
          </div>
        </div>
        <span style={badgeStyle('#d97706')}>{items.length}개</span>
      </div>

      <div style={{ marginTop: 10, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 980 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)', color: 'var(--text-sub)', fontSize: 11 }}>
              <th style={{ textAlign: 'left', padding: '7px 6px' }}>권한</th>
              <th style={{ textAlign: 'left', padding: '7px 6px' }}>현재 판단</th>
              <th style={{ textAlign: 'left', padding: '7px 6px' }}>추천 결정</th>
              <th style={{ textAlign: 'left', padding: '7px 6px' }}>확인할 점</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.code} style={{ borderBottom: '1px solid var(--border)' }}>
                <td style={{ padding: '8px 6px', verticalAlign: 'top' }}>
                  <div style={rowTitleStyle}>{item.label}</div>
                  <div style={rowMetaStyle}>{item.code}</div>
                  <div style={rowMetaStyle}>{item.source}</div>
                </td>
                <td style={{ padding: '8px 6px', verticalAlign: 'top' }}>
                  <div style={chipWrapStyle}>
                    <span style={chipStyle}>{item.currentRecommendation?.statusLabel || '검토 필요'}</span>
                    <span style={chipStyle}>
                      {item.currentPackage?.name || '검토 필요'} · {item.currentPackage?.stage || '검토'}
                    </span>
                    {item.riskLabel ? <span style={chipStyle}>위험 {item.riskLabel}</span> : null}
                  </div>
                  <div style={{ ...rowMetaStyle, marginTop: 5 }}>
                    {item.currentRecommendation?.reason || '-'}
                  </div>
                </td>
                <td style={{ padding: '8px 6px', verticalAlign: 'top' }}>
                  <span style={badgeStyle('#2563eb')}>{item.suggestedDecision}</span>
                  <div style={{ ...rowTitleStyle, marginTop: 6 }}>{item.suggestedAction}</div>
                  <div style={{ ...rowMetaStyle, marginTop: 5 }}>{item.reason}</div>
                </td>
                <td style={{ padding: '8px 6px', verticalAlign: 'top' }}>
                  <div style={{ display: 'grid', gap: 4 }}>
                    {(item.checkPoints || []).map((point) => (
                      <div key={`${item.code}-${point}`} style={rowMetaStyle}>
                        - {point}
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
